import { gql } from '@apollo/client';

export interface UserLookupVariables {
  term: string;
}

export interface UserLookupAdmin {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  active: boolean;
}

export interface UserLookupOrganisationAdmin extends UserLookupAdmin {
  organisation: { name: string };
}

export interface UserLookupLocationAdmin extends UserLookupAdmin {
  organisation: { name: string };
  location: { name: string };
}

export interface UserLookupClinician extends UserLookupAdmin {
  organisation: { name: string };
  location: { name: string };
}

export interface UserLookupResponse {
  users_admin: UserLookupAdmin[];
  users_organisation_admin: UserLookupOrganisationAdmin[];
  users_location_admin: UserLookupLocationAdmin[];
  users_clinician: UserLookupClinician[];
}

export const userLookupQuery = gql`
  query ($term: String!) {
    users_admin(where: { _or: [{ email: { _ilike: $term } }, { first_name: { _ilike: $term } }, { last_name: { _ilike: $term } }] }) {
      id
      first_name
      last_name
      email
      active
    }
    users_organisation_admin(where: { _or: [{ email: { _ilike: $term } }, { first_name: { _ilike: $term } }, { last_name: { _ilike: $term } }] }) {
      id
      first_name
      last_name
      email
      active
      organisation {
        name
      }
    }
    users_location_admin(where: { _or: [{ email: { _ilike: $term } }, { first_name: { _ilike: $term } }, { last_name: { _ilike: $term } }] }) {
      id
      first_name
      last_name
      email
      active
      organisation {
        name
      }
      location {
        name
      }
    }
    users_clinician(where: { _or: [{ email: { _ilike: $term } }, { first_name: { _ilike: $term } }, { last_name: { _ilike: $term } }] }) {
      id
      first_name
      last_name
      email
      active
      organisation {
        name
      }
      location {
        name
      }
    }
  }
`;
